import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle2, ArrowRight, AlertCircle } from 'lucide-react';

export default function SaveConfirmation({ saveResult, onNewUpload, onGoToDashboard }) {
  const { saved, skipped, errors } = saveResult;

  return (
    <Card className="pro-card max-w-lg mx-auto">
      <CardContent className="p-8 text-center space-y-6">
        <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto">
          <CheckCircle2 className="w-8 h-8 text-green-600" />
        </div>

        <div>
          <h3 className="text-xl font-semibold text-gray-800">
            {saved} Shipment{saved !== 1 ? 's' : ''} Saved
          </h3>
          <p className="text-sm text-gray-500 mt-1">
            Successfully added to your dashboard
          </p>
        </div>

        {skipped > 0 && (
          <div className="p-3 bg-amber-50 border border-amber-200 rounded-lg text-sm text-amber-700 text-left">
            <div className="flex items-center gap-2 mb-1">
              <AlertCircle className="w-4 h-4" />
              <span className="font-medium">{skipped} row{skipped !== 1 ? 's' : ''} skipped</span>
            </div>
            {errors?.length > 0 && (
              <ul className="list-disc list-inside text-xs mt-1 space-y-0.5">
                {errors.slice(0, 5).map((e, i) => (
                  <li key={i}>{e}</li>
                ))}
                {errors.length > 5 && <li>...and {errors.length - 5} more</li>}
              </ul>
            )}
          </div>
        )}

        <div className="flex gap-3 justify-center">
          <Button variant="outline" onClick={onNewUpload}>
            Upload Another File
          </Button>
          <Button
            onClick={onGoToDashboard}
            className="bg-sky-600 hover:bg-sky-700"
          >
            <ArrowRight className="w-4 h-4 mr-2" />
            Go to Dashboard
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
